import axios from 'axios';
import { UserProfileResponse } from '../../../hooks/registration';

interface SeonRequestBody {
  action_type: string;
  user_id: string;
  user_fullname?: string;
  user_firstname?: string;
  user_lastname?: string;
  user_dob?: string;
  email?: string;
  user_country?: string;
  user_city?: string;
  user_region?: string;
  user_zip?: string;
  user_street?: string;
  phone_number?: string;
  session?: string;
  brand_id: string;
}

export const seonService = async (
  user: UserProfileResponse,
  userId: string,
  actionType = 'account_creation'
): Promise<void> => {
  try {
    // Dynamically load and initialise SEON SDK only when needed
    const seonModule = await import('@seontechnologies/seon-javascript-sdk');
    const seon = seonModule.default;

    seon.init();

    // Get SEON instance and session data
    const sessionData = await seon.getSession();

    // Construct full name if both parts are available
    const fullName = user.givenName && user.familyName ? `${user.givenName} ${user.familyName}`.trim() : undefined;

    // Format phone number if available
    const phoneNumber =
      user.mobileNumber?.prefix && user.mobileNumber?.number
        ? `${user.mobileNumber.prefix}${user.mobileNumber.number}`
        : undefined;

    const requestBody: SeonRequestBody = {
      // Required fields
      action_type: actionType,
      user_id: userId,
      session: sessionData,

      // User details
      user_fullname: fullName,
      user_firstname: user.givenName || undefined,
      user_lastname: user.familyName || undefined,
      user_dob: user.birthDate ? new Date(user.birthDate).toISOString().split('T')[0] : undefined,
      email: user.email || undefined,

      // Address details
      user_country: user.address?.addressCountry || undefined,
      user_city: user.address?.addressLocality || undefined,
      user_region: user.address?.addressRegion || undefined,
      user_zip: user.address?.postalCode || undefined,
      user_street: user.address?.streetAddress || undefined,

      // Contact details
      phone_number: phoneNumber,

      // other details
      brand_id: 'itv_uk',
    };

    // Remove any undefined fields to keep the request payload clean
    Object.keys(requestBody).forEach((key) => {
      if (requestBody[key as keyof SeonRequestBody] === undefined) {
        delete requestBody[key as keyof SeonRequestBody];
      }
    });

    const response = await axios.post('/api/seon', requestBody);

    return response.data.status;
  } catch (error) {
    console.error('Error calling SEON service:', error);
    throw error;
  }
};
